<template>
	<div class="chat-setting-m-container">
		<div class="chat-setting-m-item" :class="{'chat-setting-m-item-active':currentMenu == 'basic'}" @click="menuClick('basic')">
			<span class="chat-setting-m-icon chat-setting-m-basic"></span>
			<span>基础设置</span>
		</div>
		<div class="chat-setting-m-item" :class="{'chat-setting-m-item-active':currentMenu == 'cache'}"  @click="menuClick('cache')">
			<span class="chat-setting-m-icon chat-setting-m-cache"></span>
			<span>缓存清理</span>
		</div>
	</div>
</template>

<script>
	export default{
		name:'ChatSettingMenu',
		data(){
			return{
				currentMenu:'basic'
			}
		},
		methods:{
			menuClick(val){
				this.currentMenu = val
				this.$emit('setting-menu-call',val)
			}
		}
	}
</script>

<style>
	.chat-setting-m-container{
		width: 100%;
		height: 100%;
		overflow-x: hidden;
		overflow-y: auto;
		position: relative;
		background-color: #ececec;
		color: #555555;
	}
	.chat-setting-m-container .chat-setting-m-item{
		padding: 10px 15px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		cursor: pointer;
	}
	.chat-setting-m-item:hover,.chat-setting-m-item-active{
		background-color: #e5e5e5 !important;
		border-left: 2px solid #42B983 !important;
		padding-left: 13px !important;
	}
	.chat-setting-m-item span{
		display: block;
	}
	.chat-setting-m-item .chat-setting-m-icon{
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		width: 16px;
		height: 16px;
		margin-right: 5px;
	}
	.chat-setting-m-basic{
		background-image: url(../../../assets/img/setting-70-32.png);
	}
	.chat-setting-m-cache{
		background-image: url(../../../assets/img/cache-70-32.png);
	}
</style>
